<template>
  <div class="spinner-container">
    <div class="spinner-track">
      <div class="spinner-ring"></div>
      <div class="spinner-core"></div>
    </div>
    <p class="loading-label">
      Memuat<span class="dot dot-1">.</span><span class="dot dot-2">.</span><span class="dot dot-3">.</span>
    </p>
    <p class="loading-sub">Mohon tunggu sebentar</p>
  </div>
</template>

<style scoped>
.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 3rem;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 24px;
  box-shadow: 0 8px 32px rgba(38, 72, 138, 0.18);
  border: 1px solid rgba(68, 137, 198, 0.2);
  gap: 0.5rem;
  -webkit-backdrop-filter: blur(6px); /* Required for Safari */
  backdrop-filter: blur(6px);
}

/* --- Ring track & spinning ring --- */
.spinner-track {
  position: relative;
  width: 56px;
  height: 56px;
  margin-bottom: 0.75rem;
}

.spinner-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 4px solid transparent;
  border-top-color: #26488A;
  border-right-color: #4489C6;
  border-bottom-color: #F0D25B;
  animation: spin 1s cubic-bezier(0.5, 0.15, 0.5, 0.85) infinite;
}

.spinner-core {
  position: absolute;
  inset: 12px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4489C6, #26488A);
  animation: pulse-core 1.4s ease-in-out infinite;
  box-shadow: 0 0 0 0 rgba(68, 137, 198, 0.5);
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

@keyframes pulse-core {
  0%, 100% { transform: scale(1); opacity: 1; }
  50%       { transform: scale(0.8); opacity: 0.7; }
}

/* --- Text --- */
.loading-label {
  font-family: 'Epilogue', sans-serif;
  font-size: 1.05rem;
  font-weight: 800;
  color: #26488A;
  letter-spacing: 0.5px;
  margin: 0;
}

.loading-sub {
  font-family: 'Epilogue', sans-serif;
  font-size: 0.78rem;
  font-weight: 500;
  color: #7d95b0;
  margin: 0;
}

/* --- Animated dots --- */
.dot {
  display: inline-block;
  animation: blink 1.2s step-start infinite;
}
.dot-1 { animation-delay: 0s; }
.dot-2 { animation-delay: 0.2s; }
.dot-3 { animation-delay: 0.4s; }

@keyframes blink {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0; }
}
</style>
